"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLayerContext = exports.LayerProvider = exports.layerManagerReducer = void 0;
var React = require("react");
function layerManagerReducer(state, action) {
    switch (action.type) {
        case 'push':
            if (state.find(function (layer) { return layer === action.id; })) {
                return state;
            }
            return __spreadArray(__spreadArray([], __read(state), false), [action.id], false);
        case 'pop':
            return state.filter(function (layer) { return layer !== action.id; });
        default:
            return state;
    }
}
exports.layerManagerReducer = layerManagerReducer;
var defaultValues = {
    layers: [],
    dispatchLayerAction: function () { },
    appBaseRef: { current: null },
    layerRootRef: { current: null }
};
var LayerContext = React.createContext(defaultValues);
exports.LayerProvider = LayerContext.Provider;
var useLayerContext = function () { return React.useContext(LayerContext); };
exports.useLayerContext = useLayerContext;
//# sourceMappingURL=layer-context.js.map